import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Header2 from '../components/Header2';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import db from '../firebase';


const FeedbackContent = () => {

    const [formData, setFormData] = useState({
        name: '',
        vehicleDescription: '',
        repairOrderNumber: '',
        vehicleReceived: '',
        insuranceCompany: '',
        satisfaction: '',
        customerServiceSatisfaction: '',
        repairUpdates: '',
        vehicleCleanliness: '',
        correctiveRepairs: '',
        comments: '',
        email: '',
        status: 'New'
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);

        const addFeedback = async () => {
            try {
                const docRef = await addDoc(collection(db, 'Feedback'), formData);
                console.log('Document written with ID: ', docRef.id);
                window.location.href = '/thankyou';
            } catch (e) {
                console.error('Error adding document: ', e);
            }
        };

        addFeedback();
    };

    return (
        <div className="container" style={{ marginTop: '20px', padding: '30px' }}>
            <div className="sec-title text-left">
                <h1>Feedback</h1>
            </div>
            <p>We welcome your honest feedback. Please use the form below to let us know how we did.</p>
            <p style={{ color: 'red' }}>* Required fields</p>
            <br />
            <div className="row">
                <form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="name">Your Name <span style={{ color: 'red' }}>*</span></label>
                            <input type="text" className="form-control" id="name" placeholder="Enter your name" value={formData.name} onChange={handleChange} required />
                        </div>
                        </Col>
                        <Col md={6} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                            <input type="email" className="form-control" id="email" placeholder="E-mail Address" value={formData.email} onChange={handleChange} />
                        </div>
                        </Col>
                        <Col md={6} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="vehicleDescription">Vehicle Description <span style={{ color: 'red' }}>*</span></label>
                            <input type="text" className="form-control" id="vehicleDescription" placeholder="Year Make Model" value={formData.vehicleDescription} onChange={handleChange} required />
                        </div>
                        </Col>
                        <Col md={6} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="repairOrderNumber">Repair Order Number</label>
                            <input
                                type="text"
                                className="form-control"
                                id="repairOrderNumber"
                                placeholder="Enter your Repair Order Number"
                                maxLength={5}
                                value={formData.repairOrderNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        handleChange(e);
                                    }
                                }}
                            />
                        </div>
                        </Col>
                        <Col md={6} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="vehicleReceived">How was your vehicle received by Ark-La-Tex Collision <span style={{ color: 'red' }}>*</span></label>
                            <select className="form-control" id="vehicleReceived" value={formData.vehicleReceived} onChange={handleChange} required>
                                <option value="">Select an option</option>
                                <option value="Scheduled">My vehicle was scheduled and dropped off.</option>
                                <option value="No Appointment">I dropped my vehicle off without an appointment.</option>
                                <option value="Tow In">My vehicle was towed in because it was not safe to drive.</option>
                            </select>
                        </div>
                        </Col>
                        <Col md={6} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="insuranceCompany">What insurance company did you use for this repair? <span style={{ color: 'red' }}>*</span></label>
                            <select className="form-control" id="insuranceCompany" value={formData.insuranceCompany} onChange={handleChange} required>
                                <option value="">Select an option</option>
                                <option value="Allstate">Allstate</option>
                                <option value="Farm Bureau">Farm Bureau</option>
                                <option value="Geico">Geico</option>
                                <option value="Go Auto">Go Auto</option>
                                <option value="Progressive">Progressive</option>
                                <option value="State Farm">State Farm</option>
                                <option value="Other Insurance">Other Insurance</option>
                                <option value="Self-Pay">Self-Pay</option>
                            </select>
                        </div>
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="satisfaction">From 1 being the least satisfied and 10 being the most satisfied, how satisfied are you with the repair that was done to your vehicle? <span style={{ color: 'red' }}>*</span></label>
                            <select className="form-control" id="satisfaction" value={formData.satisfaction} onChange={handleChange} required>
                                <option value="">Select a rating</option>
                                {[...Array(10)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>
                        </div>
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="customerServiceSatisfaction">From 1 being the least satisfied and 10 being the most satisfied, how satisfied were you with the customer service you received from all Ark-La-Tex Collision employees that you interacted with? <span style={{ color: 'red' }}>*</span></label>
                            <select className="form-control" id="customerServiceSatisfaction" value={formData.customerServiceSatisfaction} onChange={handleChange} required>
                                <option value="">Select a rating</option>
                                {[...Array(10)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>
                        </div>
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="repairUpdates">Were you kept updated on your repair as it progressed? <span style={{ color: 'red' }}>*</span></label>
                            <select className="form-control" id="repairUpdates" value={formData.repairUpdates} onChange={handleChange} required>
                                <option value="">Select an option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="vehicleCleanliness">Was your vehicle returned as clean or cleaner than it was when you dropped it off? <span style={{ color: 'red' }}>*</span></label>
                            <select className="form-control" id="vehicleCleanliness" value={formData.vehicleCleanliness} onChange={handleChange} required>
                                <option value="">Select an option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="correctiveRepairs">Did you have to bring your vehicle back for corrective repairs? <span style={{ color: 'red' }}>*</span></label>
                            <select className="form-control" id="correctiveRepairs" value={formData.correctiveRepairs} onChange={handleChange} required>
                                <option value="">Select an option</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                        <div className="form-group">
                            <label htmlFor="comments">Comments or Concerns</label>
                            <textarea className="form-control" id="comments" rows="3" value={formData.comments} onChange={handleChange}></textarea>
                        </div>
                        </Col>
                    </Row>
                    <button type="submit" className="col-md-3 col-sm-12 col-xs-12 btn btn-primary btn-lg pull-right">Submit</button>
                </form>
            </div>
        </div>
    );
}



const Feedback = () => {
    return (
        <>
            <Header2 />
            <FeedbackContent />
        </>
    );
};

export default Feedback;